module.exports = __webpack_public_path__ + "static/media/climbing_view_1024.d195780d.jpg";